import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import axios from "axios";
import { Multipartheader } from "../../Components/Url/ApiUrl";
import {useTranslation} from "react-i18next";

const AddModal = ({ regions, onSuccess }) => {
    const {t} = useTranslation();
    const [region, setRegion] = useState(null);
    const [type, setType] = useState(null);
    const [shartnoma, setShartnoma] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (!showModal) {
            setRegion(null);
            setType(null);
            setShartnoma(null);
        }
    }, [showModal]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!region) {
            await swal(t('translation:warning'), t('please_choose_area'), "warning");
            return;
        }
        if (!type) {
            await swal(t('translation:warning'), t('please_choose_service_center'), "warning");
            return;
        }
        if (!shartnoma) {
            await swal(t('translation:warning'), t('please_upload_contract'), "warning");
            return;
        }

        const formData = new FormData();
        formData.append("region", region);
        formData.append("type", type);
        formData.append("shartnoma", shartnoma);

        try {
            const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + "/company/company-services/region",
                formData,
                { headers: Multipartheader }
            );

            if (!res.data?.success) {
                let firstError = t('translation:saving_error');
                const message = res.data?.message;
                if (message && typeof message === "object") {
                    const firstKey = Object.keys(message)[0];
                    if (firstKey && Array.isArray(message[firstKey])) {
                        firstError = message[firstKey][0];
                    }
                } else {
                    firstError = message;
                }

                await swal(t('error'), firstError, "error");
                return;
            }

            await swal(t('saved'), t('area_add_success'), "success");
            setShowModal(false);
            onSuccess();
        } catch (err) {
            swal(t('error'), err.message || t('translation:unknown_error'), "error");
        }
    };

    return (
        <>
            <button className="btn btn-outline-secondary btn-lg ms-2" onClick={() => setShowModal(true)}>
                <i className="bi bi-plus-circle icon-3rem"></i>
            </button>

            {showModal && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <form onSubmit={handleSubmit} encType="multipart/form-data">
                                <div className="modal-header">
                                    <h5 className="modal-title">{t('add_area')}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <label htmlFor="region">{t('please_choose_area')}</label>
                                    <select
                                        className="form-control mb-2"
                                        id="region"
                                        name="region"
                                        value={region || ""}
                                        onChange={(e) => setRegion(e.target.value)}
                                        required
                                    >
                                        <option value="">---{t('translation:not_choosen')}---</option>
                                        {regions.map((region) => (
                                            <option key={region.id} value={region.id}>
                                                {region.name_l}
                                            </option>
                                        ))}
                                    </select>

                                    <label htmlFor="type">{t('service_ceter_or_store')}</label>
                                    <select
                                        className="form-control mb-2"
                                        name="type"
                                        id="type"
                                        value={type || ""}
                                        onChange={(e) => setType(e.target.value)}
                                        required
                                    >
                                        <option value="">---{t('translation:not_choosen')}---</option>
                                        <option value="Servis markazi">{t('Servis markazi')}</option>
                                        <option value="Savdo do'koni">{t("Savdo do'koni")}</option>
                                        <option value="Savdo do'koni hamda servis markazi">
                                            {t("Savdo do'koni hamda servis markazi")}
                                        </option>
                                    </select>

                                    <label htmlFor="shartnoma">{t('agreement')}</label>
                                    <input
                                        type="file"
                                        id="shartnoma"
                                        accept="application/pdf"
                                        className="form-control"
                                        name="ServiceHududlar[shartnoma]"
                                        onChange={(e) => setShartnoma(e.target.files[0])}
                                        required
                                    />
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-success">
                                        <i className="bi bi-floppy2-fill"></i> {t('save')}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setShowModal(false)}
                                    >
                                        {t('translation:cancel')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddModal;